<template>
  <div class="notice">
    <div :class="isShowMe?'orderDetails':'orderDetails hide'">
      <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
      <div class="detailList">
        <div class="dl-top">
          <div class="dl-title fl">通知列表</div>
          <div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
        </div>
         <div class="main">
           <el-table :data="tableData" height="395" highlight-current-row border :row-class-name="tableRowClassName">
            <el-table-column label="微信号" align="center"  prop="UnlockWx" ></el-table-column>
            <el-table-column label="时间" align="center"  prop="CreateDate" :formatter="formatDate"></el-table-column>
				   </el-table>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notice',
  props:{
    isShow:Boolean,
    SerialNo:String
  },
  data () {
    return {
       isShowMe:this.isShow,
       tableData:[]
    }
  },
  computed:{
    
  },
  methods: {
    closeWindow(){
			this.isShowMe=false;
    },
    noticeList(){
      const self=this;
      var data= this.common.GetlocalStorage("UnLockUserData");
      var obj=JSON.parse(data);
      var userId=obj.UserID;
      self.http.ajaxGet("NoticeList?UserID="+userId+"&SerialNo="+self.SerialNo,function(res){
          self.tableData=res.Result;
        },function(err){
          self.$alert(err, '错误', {confirmButtonText: '确定'});
      })
    },
    tableRowClassName({row, rowIndex}) {
				if (rowIndex % 2==0) {
				return 'warning-row';
				} else  {
				return 'success-row';
				}
    },
    formatDate(row, column, cellValue){
        var crtTime = new Date(row.CreateDate);
        return this.http.dateFormat("yyyy-MM-dd hh:mm:ss",crtTime);
    }
  },
  watch: {
    isShow(val) {
      this.isShowMe = val;
    },
    isShowMe(val){
      if(val){
        this.noticeList();
      }else{
        this.$emit("on-close",val);
      }
    }
  },
  mounted: function () {
     
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;left:0; background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:999; }
	.detailList{width:500px;height:470px;position: fixed; top:50%; left:50%; margin-left:-250px; margin-top:-235px;  z-index:9999; background: #fff; }
	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
	.detailList .dl-close img{ cursor: pointer;}
  .detailList .main{ padding:0 30px; font-size:16px; color:#444;}
</style>



// WEBPACK FOOTER //
// src/components/noticeList.vue